module.exports = __webpack_public_path__ + "img/view_11.da134f47.jpg";